import Vue from 'vue'
import VueToasted from 'vue-toasted'
import router from '../router'


function replacePlaceholders(message, placeholders) {
  let result = message
  if (placeholders) {
    placeholders.forEach(ph => {
      result = result.replaceAll('%' + ph.name + '%', "<span style='font-style: italic'>&nbsp;'" + ph.content + "'&nbsp;</span>")
    })
  }
  return result
}

function getToastedNotifTypeOptions(type) {
  let toastTypeOptions = {
    type: 'info',
    icon: 'icon-notification-info',
  }
  if (type === 'error') {
    toastTypeOptions = {
      type: 'error',
      icon: 'icon-notification-error'
    }
  } else if (type === 'success') {
    toastTypeOptions = {
      type: 'success',
      icon: 'icon-notification-success'
    }
  } else if (type === 'info') {
    toastTypeOptions = {
      type: 'info',
      icon: 'icon-notification-info',
    }
  }
  return toastTypeOptions
}

const defaultOpts = {
  router,
  iconPack: 'custom-class',
  className: 'fin-toast-notification',
  position: 'bottom-right',
  duration: 10000,
}

// https://github.com/shakee93/vue-toasted
const defaultOptions = {
  ...defaultOpts,
  globalToasts: {
    // Extension to handle placeholders.
    // The placeholders will be replaced and put between '.
    // see infos related to globalToasts extensions in https://github.com/shakee93/vue-toasted/blob/master/examples/reusable-toast.js
    finToast: function (payload, initiate) {
      let result = replacePlaceholders(payload.message, payload.placeholders)
      let toastTypeOptions = getToastedNotifTypeOptions(payload.type)

      return initiate(result, payload.options ? {...payload.options, ...toastTypeOptions} : {...defaultOpts, ...toastTypeOptions})
    }
  }
}

Vue.use(VueToasted, defaultOptions)

// Example
/*
this.$toasted.show('Screener saved', {
  type: 'success',
  icon: 'icon-notification-success',
  action: {
    text: "Action",
    push: {name: "finTools"}
  }
})
 */

// EXTENSIONS to display texts with placeholders.
// The placeholders will be replaced and put between '.
// Parameter:
// Object with fields message, placeholders and options
// - message: text/html with placeholders written between %-symbols
// - placeholders: (optional) array of objects with name and content of the placeholders
// - options: (optional) options as defined in VueToasted
// example how to call finToast with placeholders:
/*
  this.$toasted.global.finToast({
    message: 'my msg %placeholder1% %placeholder2%',
    placeholders: [{name: 'placeholder1', content: 'text1'}, {name: 'placeholder2', content: 'text2'}],
    type: optional // 'success', 'error', 'info'
    options: optional
  })
*/

